module.exports = __webpack_public_path__ + "static/media/appgate-light-logo.3d302af6.png";